import { ColorPartial } from '@mui/material/styles/createPalette';

type RequiredColor = Omit<Required<ColorPartial>, 'A100' | 'A200' | 'A400' | 'A700' | 800> & {
  800?: string;
};

const vPrimary: RequiredColor = {
  50: '#FFF0E9',
  100: '#FFD5C2',
  200: '#FFAC8A',
  300: '#FF8C61',
  400: '#FF7140',
  500: '#E55C2E',
  600: '#A64221',
  700: '#662A14',
  800: '#422E28',
  900: '#422E28',
};

const primary: RequiredColor = {
  50: '#F5F7F7',
  100: '#E1E3E3',
  200: '#CB99FF',
  300: '#B166FF',
  400: '#9733FF',
  500: '#000000',
  600: '#535454',
  700: '#3F0080',
  800: '#000000',
  900: '#0D001A',
};

const secondary: RequiredColor = {
  50: '#FFD5C2',
  100: '#FFAC8A',
  200: '#FFD999',
  300: '#FFC566',
  400: '#FFB233',
  500: '#FF7140',
  600: '#E55C2E',
  700: '#805000',
  800: '#662A14',
  900: '#1A1000',
};

const tertiary: RequiredColor = {
  50: '#E6F2ED',
  100: '#ADDEC9',
  200: '#99EBD2',
  300: '#66E0BC',
  400: '#33D6A5',
  500: '#03703C',
  600: '#03582F',
  700: '#006648',
  800: '#10462D',
  900: '#00140E',
};

const error: RequiredColor = {
  50: '#FFEFED',
  100: '#FED7D2',
  200: '#EB99BB',
  300: '#E0669A',
  400: '#D63378',
  500: '#AB1300',
  600: '#F1998E',
  700: '#66002B',
  800: '#5A0A00',
  900: '#140009',
};

const info: RequiredColor = {
  50: '#EFF3FE',
  100: '#D4E2FC',
  200: '#A1C7EB',
  300: '#72ACE0',
  400: '#4390D6',
  500: '#276EF1',
  600: '#174291',
  700: '#0A3A66',
  800: '#143166',
  900: '#020C14',
};

const neutral: RequiredColor & { onSurface: string } = {
  50: '#FFFFFF',
  100: '#F5F7F7',
  200: '#E1E3E3',
  300: '#B1B2B2',
  400: '#A4A9AD',
  500: '#535454',
  600: '#535454',
  700: '#323333',
  800: '#000000',
  900: '#000000',
  onSurface: '#222',
};

const grey: RequiredColor & { black: string; white: string } = {
  50: '#F5F7F7',
  100: '#EAEDED',
  200: '#E1E3E3',
  300: '#CACCCC',
  400: '#B1B2B2',
  500: '#747575',
  600: '#535454',
  700: '#323333',
  800: '#1F1F1F',
  900: '#141414',
  black: '#000000',
  white: '#ffffff',
};

const orange: RequiredColor = {
  50: '#FFF0E9',
  100: '#FFD5C2',
  200: '#FFAC8A',
  300: '#FF8C61',
  400: '#FF7140',
  500: '#E55C2E',
  600: '#A64221',
  700: '#662A14',
  800: '#e06338',
  900: '#422E28',
};

const blue: RequiredColor = {
  50: '#EFF3FE',
  100: '#D4E2FC',
  200: '#A0BFF8',
  300: '#5B91F5',
  400: '#276EF1',
  500: '#1E54B7',
  600: '#174291',
  700: '#143166',
  900: '#262F40',
};

const green: RequiredColor = {
  50: '#E6F2ED',
  100: '#ADDEC9',
  200: '#66D19E',
  300: '#06C167',
  400: '#048848',
  500: '#03703C',
  600: '#03582F',
  700: '#10462D',
  900: '#24332C',
};
const yellow: RequiredColor = {
  50: '#FFFAF0',
  100: '#FFF2D9',
  200: '#FFE3AC',
  300: '#FFCF70',
  400: '#FFC043',
  500: '#E49E15',
  600: '#996F00',
  700: '#674D1B',
  900: '#332E24',
};
const red: RequiredColor = {
  50: '#FFEFED',
  100: '#FED7D2',
  200: '#F1998E',
  300: '#E85C4A',
  400: '#E11900',
  500: '#AB1300',
  600: '#870F00',
  700: '#5A0A00',
  900: '#402926',
};
const indigo: RequiredColor = {
  50: '#F3F2FE',
  100: '#C6C0F9',
  200: '#9B90F2',
  300: '#7163E8',
  400: '#4A38DB',
  500: '#483AB8',
  600: '#443997',
  700: '#3D3678',
  900: '#2C2942',
};

const purple: RequiredColor = {
  50: '#F1EEF8',
  100: '#C9C0E2',
  200: '#A293C9',
  300: '#7C69AE',
  400: '#574191',
  500: '#503E7D',
  600: '#483B6A',
  700: '#3F3658',
  900: '#2D2938',
};

export {
  blue,
  error,
  green,
  grey,
  indigo,
  info,
  neutral,
  orange,
  primary,
  purple,
  red,
  secondary,
  tertiary,
  vPrimary,
  yellow,
};
